var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1665 5.54167C3.1665 4.04858 3.1665 3.30283 3.63042 2.83892C4.09434 2.375 4.84009 2.375 6.33317 2.375H12.6665C14.1596 2.375 14.9053 2.375 15.3693 2.83892C15.8332 3.30283 15.8332 4.04858 15.8332 5.54167V11.875C15.8332 14.1138 15.8332 15.234 15.1373 15.9291C14.4422 16.625 13.322 16.625 11.0832 16.625H7.9165C5.67767 16.625 4.55746 16.625 3.86238 15.9291C3.1665 15.234 3.1665 14.1138 3.1665 11.875V5.54167Z",
    stroke: "white",
    strokeWidth: 0.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 14.2499V16.6249M7.125 14.2499V16.6249M7.125 6.33325H11.875M7.125 9.49992H11.875",
    stroke: "white",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.96e0f7dfd7a22beab2c8dbfd7acf6779.svg";
export { ForwardRef as ReactComponent };